var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPremierepro(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.333 0H42.6667C19.1004 0 0 19.1004 0 42.6667V213.333C0 236.9 19.1004 256 42.6667 256H213.333C236.9 256 256 236.9 256 213.333V42.6667C256 19.1004 236.9 0 213.333 0Z",
    fill: "#AE4CD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.334 241.778H42.6671C26.9587 241.778 14.2227 229.042 14.2227 213.334V42.6671C14.2227 26.9587 26.9587 14.2227 42.6671 14.2227H213.334C229.042 14.2227 241.778 26.9587 241.778 42.6671V213.334C241.778 229.042 229.042 241.778 213.334 241.778Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 68.3164C64 66.4676 65.3653 64.9316 67.2071 64.7751C71.0969 64.448 78.9547 64 93.0062 64C118.521 64 136.391 74.1191 136.391 101.81C136.391 126.784 119.388 141.44 91.9538 141.44C90.3538 141.44 88.7538 141.44 83.3067 141.44V180.985C83.3067 182.948 81.7138 184.54 79.7511 184.54H67.5556C65.5929 184.54 64 182.948 64 180.985V68.3164ZM83.3067 120.313C83.3067 122.268 84.8711 123.854 86.8267 123.868C89.3795 123.883 92.5724 123.904 93.6462 123.904C109.312 123.904 116.437 114.617 116.437 102.172C116.437 90.5173 109.511 81.4293 95.0329 81.4293C91.9396 81.4293 88.9031 81.5218 86.6916 81.6071C84.7858 81.6853 83.3067 83.2569 83.3067 85.1627V120.313V120.313Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M193.47 122.788C191.031 121.053 188.186 120.185 184.937 120.185C180.535 120.185 177.086 122.297 174.611 126.529C172.122 130.76 170.892 136.513 170.892 143.794V181.327C170.892 183.289 169.299 184.882 167.337 184.882H154.167C152.204 184.882 150.611 183.289 150.611 181.327V102.393C150.611 100.431 152.204 98.8379 154.167 98.8379H167.337C169.299 98.8379 170.892 100.431 170.892 102.393V114.802H171.148C174.355 103.154 180.13 97.3232 188.478 97.3232C190.611 97.3232 192.282 97.6575 193.477 98.333V122.788H193.47Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.2227,
    y1: 128,
    x2: 241.778,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7819A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#771AA9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremierepro);
export default __webpack_public_path__ + "static/media/premierepro.ee38e1aa926f8264fdc8f6e511f2f391.svg";
export { ForwardRef as ReactComponent };